import React, { Component } from 'react';
import cx from 'classnames';

class Pick extends Component {
  constructor(props) {
    super(props);
    this.state = {imageLoaded: false};
  }
  render() {
    return (
      <div className={cx({"pick": true})}>
        <div className={cx({"pick-image": true, "image-loaded": this.state.imageLoaded, "selected": this.props.champion !== undefined})}>
          {this.props.champion
            ? <img src={`https://ddragon.leagueoflegends.com/cdn/img/champion/loading/${this.props.champion.id}_0.jpg`} alt={this.props.champion.name} onLoad={() => this.setState({imageLoaded: true})} />
            : null}
          {this.props.active ? <span className="active"></span> : null}
        </div>
        <span className="pick-name">{this.props.champion ? this.props.champion.name : null}</span>
      </div>
    );
  }
}

export default Pick;



// WEBPACK FOOTER //
// ./src/Pick.js